import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
    Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter,
} from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { MinusCircle } from "@phosphor-icons/react";

export default function CashOutDialog({ tablePlayers, onSubmit }) {
    const [open, setOpen] = useState(false);
    const [playerId, setPlayerId] = useState("");
    const [amount, setAmount] = useState("");

    const confirm = async () => {
        if (!playerId || !amount) { toast.error("Select player and amount"); return; }
        await onSubmit({ player_id: playerId, amount: parseFloat(amount) });
        setOpen(false);
        setPlayerId(""); setAmount("");
    };

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
                <Button data-testid="btn-open-cashout" variant="outline" className="h-10 border-gold/30">
                    <MinusCircle size={16} className="mr-1.5" /> Cash-out
                </Button>
            </DialogTrigger>
            <DialogContent className="bg-card">
                <DialogHeader><DialogTitle className="font-serif text-2xl">Record cash-out</DialogTitle></DialogHeader>
                <div className="space-y-3">
                    <div>
                        <Label className="label-mini">Player</Label>
                        <Select value={playerId} onValueChange={setPlayerId}>
                            <SelectTrigger data-testid="select-cashout-player"><SelectValue placeholder="Pick" /></SelectTrigger>
                            <SelectContent>
                                {tablePlayers.map(p => <SelectItem key={p.player_id} value={p.player_id}>{p.player_name}</SelectItem>)}
                            </SelectContent>
                        </Select>
                    </div>
                    <div>
                        <Label className="label-mini">Amount ($)</Label>
                        <Input data-testid="input-cashout-amount" value={amount} onChange={(e) => setAmount(e.target.value)} placeholder="150.00" />
                    </div>
                </div>
                <DialogFooter>
                    <Button data-testid="btn-confirm-cashout" onClick={confirm} className="btn-gold">Record</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
